import { Link } from "react-router-dom";
import { BAY_ISLE, TERRACOTTA, PROPER_GREY, RULE, WHITE, FONT_DISPLAY, FONT_BODY } from "../theme";

export default function Footer() {
  return (
    <div style={{ background: BAY_ISLE, padding: "2.5rem 24px 1.75rem", marginTop: "auto" }}>
      <div style={{
        maxWidth: 1000, margin: "0 auto", display: "flex", flexWrap: "wrap",
        justifyContent: "space-between", gap: 24, marginBottom: 24,
      }}>
        <div style={{ maxWidth: 280 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <div style={{
              width: 38, height: 38, borderRadius: "50%", background: WHITE,
              display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
              padding: 4,
            }}>
              <img src="/assets/acadia-logo.png" alt="Acadia Media & Marketing" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </div>
            <p style={{ fontSize: 15, fontWeight: 700, color: WHITE, fontFamily: FONT_DISPLAY, margin: 0 }}>
              Acadia Media & Marketing
            </p>
          </div>
          <p style={{ fontSize: 12.5, color: "rgba(242,238,234,0.55)", lineHeight: 1.6, fontFamily: FONT_BODY }}>
            The smarter way to show up online. AI-powered marketing for Hudson Valley real estate agents.
          </p>
        </div>

        <div style={{ display: "flex", gap: 40, flexWrap: "wrap" }}>
          <div>
            <p style={{
              fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase",
              color: TERRACOTTA, marginBottom: 12, fontFamily: FONT_BODY,
            }}>Site</p>
            {[
              { to: "/", label: "Home" },
              { to: "/about", label: "About" },
              { to: "/for-agents", label: "For Agents" },
              { to: "/for-businesses", label: "For Businesses" },
              { to: "/products", label: "Products" },
              { to: "/get-started", label: "Get Started" },
              { to: "/contact", label: "Contact" },
            ].map(l => (
              <Link key={l.to} to={l.to} style={{
                display: "block", fontSize: 12.5, color: "rgba(242,238,234,0.7)",
                textDecoration: "none", marginBottom: 8, fontFamily: FONT_BODY,
              }}>{l.label}</Link>
            ))}
          </div>

          <div>
            <p style={{
              fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase",
              color: TERRACOTTA, marginBottom: 12, fontFamily: FONT_BODY,
            }}>Connect</p>
            <p style={{ fontSize: 12.5, color: "rgba(242,238,234,0.7)", marginBottom: 8, fontFamily: FONT_BODY }}>
              @acadiamediamarketing
            </p>
            <p style={{ fontSize: 12.5, color: "rgba(242,238,234,0.7)", fontFamily: FONT_BODY }}>
              inquiries@acadiamediamarketing.com
            </p>
          </div>
        </div>
      </div>

      <div style={{
        maxWidth: 1000, margin: "0 auto", paddingTop: 18,
        borderTop: "1px solid rgba(242,238,234,0.12)",
        display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8,
      }}>
        <p style={{ fontSize: 11, color: "rgba(242,238,234,0.4)", fontFamily: FONT_BODY }}>
          © 2026 Acadia Media & Marketing. Hudson Valley, NY.
        </p>
        <p style={{ fontSize: 11, color: "rgba(242,238,234,0.4)", fontFamily: FONT_BODY, fontStyle: "italic" }}>
          The smarter way to show up online.
        </p>
      </div>
    </div>
  );
}
